export interface RegistrationAbuseErrorPayload {
  message: string;
  pricing_url: string;
}

export interface EmailNotVerifiedErrorPayload {
  code: 'EMAIL_NOT_VERIFIED';
  message: string;
  email: string;
}

export function isRegistrationAbuseErrorPayload(
  value: unknown
): value is RegistrationAbuseErrorPayload {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }
  const record = value as Record<string, unknown>;
  return (
    typeof record.message === 'string' &&
    typeof record.pricing_url === 'string' &&
    record.message.length > 0 &&
    record.pricing_url.length > 0
  );
}

export function isEmailNotVerifiedErrorPayload(
  value: unknown
): value is EmailNotVerifiedErrorPayload {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }
  const record = value as Record<string, unknown>;
  return (
    record.code === 'EMAIL_NOT_VERIFIED' &&
    typeof record.message === 'string' &&
    typeof record.email === 'string'
  );
}

export function parseAuthErrorDetail(detail: unknown): RegistrationAbuseErrorPayload | null {
  if (isRegistrationAbuseErrorPayload(detail)) {
    return detail;
  }
  return null;
}

export function formatAuthErrorFromResponse(error: {
  response?: { data?: { detail?: unknown; message?: unknown } };
  message?: string;
}): string | RegistrationAbuseErrorPayload | EmailNotVerifiedErrorPayload {
  const detail = error.response?.data?.detail;
  if (isEmailNotVerifiedErrorPayload(detail)) {
    return detail;
  }
  const structured = parseAuthErrorDetail(detail);
  if (structured) {
    return structured;
  }
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail
      .map((item: { msg?: string }) => (typeof item?.msg === 'string' ? item.msg : String(item)))
      .join(', ');
  }
  const message = error.response?.data?.message;
  if (typeof message === 'string') {
    return message;
  }
  if (typeof error.message === 'string') {
    return error.message;
  }
  return 'Request failed';
}
